import React from 'react';
import { Meta } from '../../styled components/Typography';
import { bookingCount } from '../../libs/listViewPresentation';
import type { ListViewBooking } from '../types';

interface ListViewBookingCountProps {
  booking: ListViewBooking;
}

/* How many of the resource a booking books, beside the resource's name:
 * "Projector × 2". The count has no column of its own in either view mode -
 * it says nothing without the name it belongs to - so this is what both put
 * after the name, and what a set's members already showed.
 *
 * It stays on the name's line, whatever room the name is left with: it never
 * wraps in itself, it is never the element that gives way (the name is - it is
 * truncated in the table and wrapped on a card), and every place it is used
 * puts it on a row that does not wrap - see ChildBookingLabel, CardTitleLabel
 * and NestingCellContent.
 *
 * Shown for a booking of one as well as for a booking of several: the count
 * is a value of the booking like any other, and one that appears only above
 * one would read as a value that went missing. Nothing at all only for a
 * booking that reports no count (see bookingCount). Smaller and greyer than
 * the name, so a scan down the column reads the names first. */
const ListViewBookingCount = ({ booking }: ListViewBookingCountProps) => {
  const count = bookingCount(booking);
  if (count === null) return null;
  return (
    <Meta
      tw="shrink-0 ml-4 whitespace-nowrap"
      $color="gray dark"
      data-test-list-view-booking-count
    >
      × {count}
    </Meta>
  );
};

export default ListViewBookingCount;
